import { Component } from 'react';
import ClientInfoContext from '../../contexts/ClientInfoContext';
import { IIbanUpdateWithDocumentError } from '../../interfaces/IIbanUpdate';
import DocumentService from '../../services/DocumentService';
import IbanUpdateDetailsModal from '../IbanUpdateDetailsModal/IbanUpdateDetailsModal';
import IbanUpdatePanelCardItem from '../IbanUpdatePanelCardItem/IbanUpdatePanelCardItem';
import { default as IIbanUpdateCardState, default as IOrderPanelCardState } from './IIbanUpdateCardState';
import IIbanUpdateCardProps from './IIbanUpdatePanelCardProps';

export default class IbanUpdatePanelCard extends Component<IIbanUpdateCardProps, IIbanUpdateCardState> {
  public readonly state: IOrderPanelCardState = {
    isModalOpen: false,
    loading: true,
  };

  private readonly ibanUpdate: IIbanUpdateWithDocumentError = this.props.ibanUpdate;

  public async componentDidMount(): Promise<void> {
    if (!this.ibanUpdate.document) {
      this.setState({ loading: false });
      return;
    }

    const documentService = new DocumentService();

    const document = await documentService.getDocument(this.ibanUpdate.document);

    this.ibanUpdate.errors = document.data.errors;
    this.setState({ loading: false });
  }

  public render() {
    const { isModalOpen, loading } = this.state;

    if (loading) {
      return null;
    }

    return (
      <ClientInfoContext.Consumer>
        { ({ user }) => (
          <>
            <IbanUpdateDetailsModal
              isIbanUpdateDetailsModalOpen={isModalOpen}
              ibanUpdate={this.ibanUpdate}
              handleCloseModal={this.handleCloseModal}
              investmentAccounts={user.investmentAccounts}
            />

            <IbanUpdatePanelCardItem ibanUpdate={this.ibanUpdate} handleOpenModal={this.handleOpenModal} />
          </>
        ) }
      </ClientInfoContext.Consumer>
    );
  }

  private handleOpenModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  private handleCloseModal = async (hasChangedValue?: boolean) => {
    const { updateIbanUpdate } = this.props;

    if (hasChangedValue) {
      await updateIbanUpdate();
    }

    this.setState({
      isModalOpen: false,
    });
  };
}
